import styled from "styled-components"

export const StyledFoodDetails = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

export const FoodDetailsHeader = styled.div`
  position: absolute;
  height: 44px;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 1000;
  padding: 0px var(--app-horizontal-padding);
`

export const FoodDetailsContent = styled.div`
  height: calc(100% - var(--app-cta-height));
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export const FoodDetailsBody = styled.div`

  height:100%:
`

export const FoodDetailsInfo = styled.div`
  padding: var(--app-horizontal-padding);
  padding-bottom: 0;
  gap: 8px;
  display: flex;
  flex-direction: column;
  margin-top: -50px;
  z-index: 100;
  position: relative;
  padding-top: 0;
`

export const IngredientList = styled.div``
export const IngredientListTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
  margin-bottom: 8px;
`
